/* The grey required lock, promoted out of `pages/reports/ui/canon.module.css` on 17 September 2026
 * when `features/survey-report` became its fourth consumer and its first outside `/raporty`.
 *
 * Two declarations and no geometry beyond the glyph's own square: the mark stands beside a label
 * like a piece of punctuation, so it takes the ink and the size and nothing else. `--sz-glyph-md`
 * is the app's own 16px glyph step; `/raporty`'s `--sz-report-glyph-md` was the same number under a
 * screen-scoped name, and a shared component may not read a page's token. */

/* `vertical-align: middle` is load-bearing, not tidiness. An inline-flex box takes its baseline from
 * its first in-flow child, and that child is a replaced `<svg>` whose baseline is its own bottom
 * edge — so the lock sat with its foot on the text's baseline and read as a superscript beside every
 * label that carries it. Aligned on the middle it sits ON the line, which is what a piece of
 * punctuation does. Reported on the survey report's ODPOWIEDZI band (owner, 17 September 2026); the
 * same 3px lift was on all four surfaces that draw the mark. */
.requiredMark {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  color: var(--text-3);
}

.requiredIcon {
  display: block;
  width: var(--sz-required-lock);
  height: var(--sz-required-lock);
}
